module.exports = __webpack_public_path__ + "static/assets/842f88b26adc80675e4516989d6dbcf5.png";